'use strict';

var React = require('react');
var Text$1 = require('@swiggy-private/dls-web-core/dist/components/Text');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const defaultAttributes = {
    variant: "header_H1",
};
const TextComp = ({ text, attrs = defaultAttributes, style, as = "div", }) => {
    return (React__default['default'].createElement(Text$1.Text, Object.assign({ as: as, style: style }, attrs), text));
};
var Text = React__default['default'].memo(TextComp);

exports.Text = Text;
//# sourceMappingURL=Text-fd66b8ee.js.map
